module.exports = __webpack_public_path__ + "img/empty-image.6a1085a2.png";